var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiPeopleCountingGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.383,
    height: 89.177,
    viewBox: "0 0 93.383 89.177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8069",
    "data-name": "Path 8069",
    d: "M34.163,69.589V67.1A7.582,7.582,0,0,0,19,67.1v2.487a7.582,7.582,0,1,0,15.163,0Zm-2.729,0a4.853,4.853,0,1,1-9.706,0V67.1a4.853,4.853,0,0,1,9.706,0ZM84.327,87.982A7.592,7.592,0,0,0,91.911,80.4V77.911a7.583,7.583,0,1,0-15.165,0V80.4A7.591,7.591,0,0,0,84.327,87.982ZM79.474,77.911a4.854,4.854,0,1,1,9.708,0V80.4a4.854,4.854,0,1,1-9.708,0V77.911Zm-6.7-8.322V67.1a7.582,7.582,0,0,0-15.163,0v2.487a7.582,7.582,0,0,0,15.163,0Zm-2.729,0a4.853,4.853,0,0,1-9.706,0V67.1a4.853,4.853,0,0,1,9.706,0ZM103.8,59.518A7.591,7.591,0,0,0,96.22,67.1v2.487a7.582,7.582,0,1,0,15.163,0V67.1A7.582,7.582,0,0,0,103.8,59.518Zm4.853,10.071a4.853,4.853,0,1,1-9.706,0V67.1a4.853,4.853,0,1,1,9.706,0ZM45.887,60.955a7.59,7.59,0,0,0,7.582-7.582V50.884a7.582,7.582,0,0,0-15.163,0v2.489A7.59,7.59,0,0,0,45.887,60.955ZM41.034,50.884a4.853,4.853,0,0,1,9.706,0v2.489a4.853,4.853,0,0,1-9.706,0ZM84.327,60.955a7.591,7.591,0,0,0,7.584-7.582V50.884a7.583,7.583,0,1,0-15.165,0v2.489A7.59,7.59,0,0,0,84.327,60.955ZM79.474,50.884a4.854,4.854,0,1,1,9.708,0v2.489a4.854,4.854,0,1,1-9.708,0V50.884ZM65.192,47.44a7.59,7.59,0,0,0,7.582-7.582V37.372a7.582,7.582,0,0,0-15.163,0v2.487A7.59,7.59,0,0,0,65.192,47.44ZM60.339,37.372a4.853,4.853,0,0,1,9.706,0v2.487a4.853,4.853,0,0,1-9.706,0ZM45.887,87.982A7.591,7.591,0,0,0,53.468,80.4V77.911a7.582,7.582,0,0,0-15.163,0V80.4A7.591,7.591,0,0,0,45.887,87.982ZM41.034,77.911a4.853,4.853,0,1,1,9.706,0V80.4a4.853,4.853,0,0,1-9.706,0Zm11.2,13.16a1.365,1.365,0,0,0-.6.139l-5.73,2.809-5.529-2.8a1.364,1.364,0,0,0-.617-.147,12.377,12.377,0,0,0-12.374,12.376V116.6a1.364,1.364,0,0,0,1.364,1.364H63.024a1.364,1.364,0,0,0,1.364-1.364v-13.38A12.166,12.166,0,0,0,52.237,91.071ZM45.9,98.3l.653,10.837-.629.568-.7-.628ZM61.66,115.239H30.115V103.447A9.649,9.649,0,0,1,39.444,93.8l3.88,1.965-.863,13.792a1.364,1.364,0,0,0,.45,1.1l2.1,1.891a1.364,1.364,0,0,0,1.827,0l2.027-1.832a1.364,1.364,0,0,0,.447-1.094L48.483,95.8,52.544,93.8a9.435,9.435,0,0,1,9.117,9.419v12.015ZM90.677,91.071a1.365,1.365,0,0,0-.6.139l-5.73,2.809-5.527-2.8a1.364,1.364,0,0,0-.617-.147,12.377,12.377,0,0,0-12.376,12.375V116.6a1.364,1.364,0,0,0,1.364,1.364h34.273a1.364,1.364,0,0,0,1.364-1.364v-13.38A12.166,12.166,0,0,0,90.677,91.071ZM84.339,98.3l.653,10.837-.629.568-.7-.628ZM100.1,115.239H68.556V103.447a9.649,9.649,0,0,1,9.33-9.643l3.877,1.964L80.9,109.562a1.364,1.364,0,0,0,.45,1.1l2.1,1.891a1.364,1.364,0,0,0,1.827,0l2.027-1.832a1.364,1.364,0,0,0,.447-1.094L86.922,95.8,90.983,93.8a9.435,9.435,0,0,1,9.117,9.419v12.015Z",
    transform: "translate(-19 -29.79)",
    fill: "#78bc27",
    stroke: "#f3f9fd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8061",
    "data-name": "Path 8061",
    d: "M434.635,195.547v2.487a6.217,6.217,0,0,1-12.435,0v-2.487a6.217,6.217,0,0,1,12.435,0Z",
    transform: "translate(-343.616 -158.236)",
    fill: "#78bc27",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8062",
    "data-name": "Path 8062",
    d: "M300.533,276.315V289.7H266.26V276.539a11.013,11.013,0,0,1,11.011-11.012l6.131,3.107-1.189,0-.883,14.1,2.1,1.891,2.027-1.832-.854-14.165-1.2,0,6.336-3.107a10.788,10.788,0,0,1,10.788,10.788ZM289.615,251v2.487a6.218,6.218,0,1,1-12.437,0V251a6.218,6.218,0,1,1,12.437,0Z",
    transform: "translate(-218.069 -202.882)",
    fill: "#78bc27",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8063",
    "data-name": "Path 8063",
    d: "M334.717,112.333v2.489a6.218,6.218,0,0,1-12.437,0v-2.489a6.218,6.218,0,0,1,12.437,0Z",
    transform: "translate(-263.17 -91.239)",
    fill: "#78bc27",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8064",
    "data-name": "Path 8064",
    d: "M236.535,195.547v2.487a6.217,6.217,0,1,1-12.435,0v-2.487a6.217,6.217,0,1,1,12.435,0Z",
    transform: "translate(-184.126 -158.236)",
    fill: "#78bc27",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8065",
    "data-name": "Path 8065",
    d: "M236.535,43.007v2.487a6.217,6.217,0,1,1-12.435,0V43.007a6.217,6.217,0,1,1,12.435,0Z",
    transform: "translate(-184.126 -35.426)",
    fill: "#78bc27",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8066",
    "data-name": "Path 8066",
    d: "M103.3,276.319V289.7H69.03V276.543a11.013,11.013,0,0,1,11.009-11.012l6.133,3.107-1.189,0-.883,14.1,2.1,1.891,2.027-1.832-.854-14.165-1.2,0,6.336-3.107A10.788,10.788,0,0,1,103.3,276.319Zm-10.92-25.312v2.487a6.217,6.217,0,1,1-12.435,0v-2.487a6.217,6.217,0,0,1,12.435,0Z",
    transform: "translate(-59.279 -202.886)",
    fill: "#78bc27",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8067",
    "data-name": "Path 8067",
    d: "M137.485,112.337v2.489a6.217,6.217,0,0,1-12.435,0v-2.489a6.217,6.217,0,1,1,12.435,0Z",
    transform: "translate(-104.381 -91.243)",
    fill: "#78bc27",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8068",
    "data-name": "Path 8068",
    d: "M38.435,195.547v2.487a6.217,6.217,0,1,1-12.435,0v-2.487a6.217,6.217,0,0,1,12.435,0Z",
    transform: "translate(-24.636 -158.236)",
    fill: "#78bc27",
    opacity: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiPeopleCountingGreen);
export default __webpack_public_path__ + "static/media/ai_people_counting_green.96cbd149d652d03d65053e2ae45a2bc7.svg";
export { ForwardRef as ReactComponent };